export const frequentlyAskedQuestionsMessages = {
  frequentlyAskedQuestionId: 'Mã quản lý',
  title: 'Tiêu đề',
  content: 'Nội dung',
  keyword: 'Từ khoá',
  serviceType: 'Loại dịch vụ',
  priority: 'Độ ưu tiên',
  isActive: 'Trạng thái hoạt động',
  create: 'Tạo mới hỏi đáp KB',
  update: 'Cập nhật hỏi đáp KB',
  delete: 'Xóa hỏi đáp',
  confirmDelete: 'Bạn có chắc chắn muốn xóa thông tin hỏi đáp này không?',
  status: 'Trạng thái',
  general: 'Thông tin chung'
};
